import React from "react";
import ClientHeader from "../../Share/ClientHeader";
import { Outlet } from "react-router-dom";
import ClientFooter from "../../Share/ClientFooter";
import Messenger from "../../Share/Component/Messenger";
import useClientAuthSession from "../../Hooks/useClientAuthSession";

function ClientPage() {
  const isAuthenticated = useClientAuthSession();

  return (
    <div>
      <ClientHeader />
      <Outlet />
      {isAuthenticated ? (
        <>
          <Messenger />
          <ClientFooter />
        </>
      ) : null}
    </div>
  );
}

export default ClientPage;